const boxOrange = 6
const boxRed = 7
const boxBlue = 8
const boxGreen = 9
const boxGrey = 10

const targetOrange = 25
const targetRed = 38
const targetBlue = 51
const targetGreen = 64
const targetGrey = 77

export {
  boxOrange,
  boxRed,
  boxBlue,
  boxGreen,
  boxGrey,
  
  targetOrange,
  targetRed,
  targetBlue,
  targetGreen,
  targetGrey,
}